import { render, staticRenderFns } from "./veStuLiteraryProgramMy.vue?vue&type=template&id=39efb4b1&scoped=true"
import script from "./veStuLiteraryProgramMy.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryProgramMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39efb4b1",
  null
  
)

export default component.exports